import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector,useDispatch } from 'react-redux';
import { titleCase } from 'shared/modifiers';
import { COUNTDOWN_TYPE, CountdownHoc } from './CountdownHoc';

import './salecard.scss';
import { addDataLayer } from 'shared/utils/utils';
import { Link } from 'react-router-dom';

const SaleCard = ({ sale, navigate, saleBoard=false, props }) => {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const [isSaleClosed, setIsSaleClosed] = useState(sale.status === 'Closed' ? true : false);
    const [saleitemreceiptmethod, setsaleitemreceiptmethod] = useState(JSON.parse(sale?.saleitemreceiptmethod) || {});
    const [itemImg, setitemImg] = useState(typeof sale.itemimageurl === 'string' ? JSON.parse(sale.itemimageurl) : []);

    const handleNavigate = () => {
        let dataLayerData = {
            'event': "explore_sale",
            'title': sale.id
        }
        addDataLayer(dataLayerData);
        navigate(sale);
        let pusttoStore = { ...statemaintenance }
        delete pusttoStore["EstateItemList"]
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
    };

    const viewMoreLocation = () => {
        let dataLayerData = {
            'event': "viewmore_location"
        }
        addDataLayer(dataLayerData);
        const scrollContainer = document.querySelector('.scroll-content');
        let pusttoStore = { ...statemaintenance }
         pusttoStore["Estate-Sale-List"] = {
            ...pusttoStore?.["Estate-Sale-List"],
            scrollindex:scrollContainer.scrollTop
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        const url = sale.locationcode ? `/estate-sales/${sale.locationstatecode}/${sale.locationcode}` : `/estate-sales/${sale.locationstatecode}`;
        props.history.push(url);
    }

    return (
        <div className="salecard">
            <div className="d-flex align-items-center justify-content-between">

                {
                    sale.status === 'Started' ? 
                    <CountdownHoc type={COUNTDOWN_TYPE.SALE} targetTime={sale.endtimeutc} saleId={sale.id} displayAsRow={!saleBoard} onDoneCallback={() => setIsSaleClosed(true)} /> : 
                    <div className='text-danger'>Closed</div>
                }

                <div className={`${!saleBoard ?"d-flex-resp gap3 " : "sale-card-item-count"} align-items-center`} >
                    <div>Items</div>
                    <div className='text-center'>
                        <div className='highlight-itemcount text-bold'>{isSaleClosed ? 0 : sale.itemcount} </div>
                    </div>
                </div>
            </div>

            <div aria-label={`${sale.title}`} title={sale.title} className='sale-title'>{sale.title}</div>

            {
                !saleBoard &&
                <div className='d-flex gap3'>
                    {saleitemreceiptmethod?.shipping && <div className='shipping'>{"SHIPPABLE"}</div>}
                    {!saleitemreceiptmethod?.shipping && saleitemreceiptmethod?.pickup && <div className='pickup'>{"PICK UP ONLY"}</div>}
                    {/* <div className='onsite'>ON-SITE ONLY</div> */}
                    {/* <div>{sale.saleimageurl}</div> */}
                </div>
            }
            <Link to={`/estate-sale/${sale.id}`} onClick={(e) => {
                // Allow browser default for ctrl/cmd/middle-click
                if (
                    e.metaKey || // macOS Cmd key
                    e.ctrlKey || // Windows/Linux Ctrl key
                    e.button === 1 // Middle mouse button
                ) return;
                e.preventDefault();
                addDataLayer({
                    'event': "explore_sale",
                    'title': sale.id
                });
                handleNavigate();
            }}> 
            <div className='sale-image-view clickable'>
                <img
                    src={sale.url ? sale.url : sale?.staticcoverimage}
                    alt={`${sale.title}`}
                    className={`sale-image ${!sale.url ? 'no-image' : ''}`}
                />
                <div className='itemimagecard image1'><img loading='lazy' alt="sale-secondary-img1" className={`itemimg `} src={itemImg?.[0] ? itemImg[0] : sale?.staticinsertimage} /></div>
                <div className='itemimagecard image2'><img loading='lazy' alt="sale-secondary-img2" className={`itemimg `} src={itemImg?.[1] ? itemImg[1] : sale?.staticinsertimage} /></div>
                <div className='itemimagecard image3'><img loading='lazy' alt="sale-secondary-img3" className={`itemimg `} src={itemImg?.[2] ? itemImg[2] : sale?.staticinsertimage} /></div>
                
            </div>
            </Link>
            <div className='container'>
                <div className='provenanceView' >
                    <div className='provenance'>{sale?.provenance}</div>
                </div>

                {saleBoard && <div className="borderui"></div>}
                {saleBoard ?
                    <div className={`d-flex align-items-center gap3 py-2`}>
                        <div className='sub-head'>Location</div>
                        <div>
                            <div className='sub-text'>{titleCase(sale?.city)}, {titleCase(sale?.state)}, {titleCase(sale?.zipcode)}</div>
                        </div>
                    </div> :
                    <div className="d-flex-resp align-items-start justify-content-between w-50 py-2">
                        <div className='d-flex flex-column gap-2 '>
                            <div className='sub-head'>Location</div>
                            <div>
                                <div className='sub-text'>{titleCase(sale?.city)}, {titleCase(sale?.state)}</div>
                                <div className='sub-text'>{titleCase(sale?.zipcode)}</div>
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-2'>
                            <div className='sub-head'>Item Details</div>
                            <div>
                                <div className='sub-text'>{sale?.itemcount} items total</div>
                            </div>
                        </div>
                    </div>}

                <div className="d-flex-resp align-items-center gap20 py-2" >
                    <Button className='btn-secondary rounded' onClick={() => { handleNavigate() }}>Explore this Estate Sale</Button>
                    {
                        !saleBoard &&
                        <Button className='btn-white rounded text-navy' style={{ borderColor: "#DEE2E6" }} onClick={() => {viewMoreLocation()}}>
                            View more from this location
                        </Button>
                    }
                </div>
            </div>
        </div>
    );
};

export default SaleCard;

